<template>
  <div>
    <label :for="idInner" v-if="libelleLong">
      <div class="d-flex mb-2">
        <div v-html="libelleLong"></div>
        <span class="ml-1 red--text" v-if="!optionel">*</span>
      </div>
    </label>
    <infobulle v-if="descriptionPopup" :descriptionPopup="descriptionPopup"> </infobulle>

    <template v-if="modeAffichageCatalogue === 'RADIO'">
      <v-radio-group v-bind="$attrs" @change="handleChange" class="ml-3 mt-0" :rules="catalogueRules" :value="value" :dense="isDense">
        <div v-for="item in valeurs" :key="item.value">
          <v-radio :value="item.value" class="my-1">
            <template v-slot:label>
              <span v-html="item.text"></span>
            </template>
          </v-radio>
        </div>
      </v-radio-group>
    </template>

    <template v-if="modeAffichageCatalogue == 'CHECKBOX'">
      <div v-for="item in valeurs" :key="item.value">
        <v-checkbox :value="item.value" hide-details @change="handleChange" v-model="checkboxValue" class="my-1" v-bind="$attrs">
          <template v-slot:label>
            <div v-html="item.text"></div>
          </template>
        </v-checkbox>
      </div>

      <v-checkbox
        class="list_counter_validator my-2 p-0"
        :input-value="checkboxValue.length > 0"
        :rules="[(v) => champ.optionel || !!v || 'Sélectionner au moins un élément']"
      ></v-checkbox>
    </template>

    <template v-if="modeAffichageCatalogue == 'AUTOCOMPLETE'">
      <v-autocomplete
        :id="idInner"
        :label="label"
        :style="{ width: largeurMaxEnPx }"
        :items="valeurs"
        v-bind="$attrs"
        :value="value"
        @change="handleChange"
        :rules="catalogueRules"
        :dense="isDense"
        :outlined="isOutlined"
        :multiple="isMultiple"
        clearable
        auto-select-first
        deletable-chips
      >
      </v-autocomplete>
    </template>

    <template v-if="modeAffichageCatalogue == 'SELECT'">
      <v-select
        :id="idInner"
        :label="label"
        :value="value"
        :style="{ width: largeurMaxEnPx }"
        :items="valeurs"
        v-bind="$attrs"
        @change="handleChange"
        :rules="catalogueRules"
        :dense="isDense"
        :outlined="isOutlined"
        :chips="isMultiple"
        :multiple="isMultiple"
        clearable
        deletable-chips
      ></v-select>
    </template>

    <template v-if="modeAffichageCatalogue == 'BUTTON_GROUP'">
      <div :style="{ width: largeurMaxEnPx }">
        <v-btn-toggle
          :id="idInner"
          :value="value"
          @change="handleChange"
          tile
          group
          :dense="isDense"
          :multiple="isMultiple"
          v-bind="$attrs"
          :color="color || 'primary'"
        >
          <v-btn v-for="item in valeurs" :key="item.value" :value="item.value">
            {{ item.text }}
          </v-btn>
        </v-btn-toggle>
        <v-checkbox
          class="list_counter_validator my-2 p-0"
          :input-value="!!value"
          :rules="[(v) => champ.optionel || !!v || 'Sélectionner au moins un élément']"
        ></v-checkbox>
      </div>
    </template>
  </div>
</template>
   

<script>
import { mapGetters } from "vuex"
import ChampBase from "@/components/ui/mixins/ChampBase"
export default {
  mixins: [ChampBase],
  data() {
    return {
      checkboxValue: [],
      largeurMax: 500
    }
  },
  props: {
    items: Array,
    filter: { type: Function },
    parent: String,
    color: String,
    orderBy: { type: String, default: "code" }
  },
  computed: {
    ...mapGetters(["catalogues"]),
    modeAffichageCatalogue() {
      return this.champ?.modeAffichageCatalogue ?? ""
    },
    catalogueReference() {
      return this.champ?.catalogueReference ?? ""
    },
    isMultiple() {
      return this.champ?.multiple ?? false
    },
    catalogueRules() {
      return [
        (v) => {
          if (this.optionel) {
            return true
          }
          if (this.isMultiple) {
            return (!!v && v.length > 0 && v.every((c) => this.valeurs.map((m) => m.value).indexOf(c) > -1)) || this.champObligatoireMessage
          } else {
            return this.valeurs.map((m) => m.value).indexOf(v) > -1 || this.champObligatoireMessage
          }
        }
      ]
    },
    valeurs() {
      let items = this.items || this.catalogues?.get(this.catalogueReference) || []

      let filter = items.filter((fd) => {
        if (this.parent && fd.parent != this.parent) {
          return false
        }

        if (this.filter && !this.filter(fd)) {
          return false
        }

        return true
      })
      this.sortBy(filter, this.orderBy)

      return filter
    }
  },

  methods: {
    handleChange(event) {
      this.$emit("input", event)
    },
    checkAll() {
      if (this.modeAffichageCatalogue == "checkbox") {
        this.checkboxValue = this.valeurs.map((v) => v.value)
      }
      this.handleChange(this.valeurs.map((v) => v.value))
    },
    sortBy(arr, key) {
      arr.sort((a, b) => Intl.Collator().compare(a[key], b[key]))
    },
    setValue(value) {
      if (this.modeAffichageCatalogue == "checkbox") {
        this.value = [value]
      }
      this.handleChange(value)
    },
    setValueByCode(code) {
      let value = this.valeurs.find((fd) => fd.code == code)
      if (value) {
        this.setValue(value.value)
      }
    },
    removeValuesByCodes(codes) {
      if (this.modeAffichageCatalogue == "checkbox") {
        for (let i = 0; i < codes.length; i++) {
          let value = this.allValeurs.find((fd) => fd.code == codes[i])
          let index = this.checkboxValue.indexOf(value.value)
          if (index > -1) {
            this.checkboxValue.splice(index, 1)
          }
        }
        this.handleChange(this.checkboxValue)
      }
    }
  }
}
</script>

<style>
.list_counter_validator > .v-input__control > .v-input__slot {
  display: none !important;
}
.list_counter_validator > .v-input__control > .v-messages {
  font-size: inherit;
}
</style>